// Sticker configuration for Women Protection Platform
// Each sticker has: id, name, file, position, size, rotation (degrees)

export const STICKER_POSITIONS = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center',
  LEFT_CENTER: 'left-center',
  RIGHT_CENTER: 'right-center',
};

// Size as percentage of image width
export const STICKER_SIZES = {
  SMALL: 0.15,    // 15% of image width
  MEDIUM: 0.22,   // 22% of image width
  LARGE: 0.30,    // 30% of image width
  XLARGE: 0.38,   // 38% of image width
};

export const STICKERS = [
  {
    id: 'dubai-logo',
    name: 'Dubai Police Logo',
    nameAr: 'شعار شرطة دبي',
    file: 'dubai-logo.png',
    position: STICKER_POSITIONS.TOP_RIGHT,
    size: STICKER_SIZES.MEDIUM,
    rotation: 15, // degrees (0 = no rotation, positive = clockwise)
    category: 'corner',
  },
  {
    id: 'green-heart',
    name: 'Green Heart',
    nameAr: 'قلب أخضر',
    file: 'green-heart.png',
    position: STICKER_POSITIONS.TOP_LEFT,
    size: STICKER_SIZES.MEDIUM,
    rotation: -15, // slight tilt
    category: 'corner',
  },
  {
    id: 'orange-hand',
    name: 'Support Hand',
    nameAr: 'يد الدعم',
    file: 'orange-hand.png',
    position: STICKER_POSITIONS.BOTTOM_RIGHT,
    size: STICKER_SIZES.MEDIUM,
    rotation: 0,
    category: 'corner',
  },
  {
    id: 'you-deserve-sticker',
    name: 'You Deserve',
    nameAr: 'تستحقين',
    file: 'you-deserve-sticker.png',
    position: STICKER_POSITIONS.BOTTOM_LEFT,
    size: STICKER_SIZES.LARGE,
    rotation: 0,
    category: 'corner',
  },
  {
    id: 'dubai-supports-you',
    name: 'Dubai Supports You',
    nameAr: 'دبي تدعمك',
    file: 'dubai-supports-you.png',
    position: STICKER_POSITIONS.TOP_LEFT,
    size: STICKER_SIZES.XLARGE,
    rotation: -20,
    category: 'top',
  },
  {
    id: 'you-are-hero',
    name: 'You Are Hero',
    nameAr: 'أنتِ بطلة',
    file: 'you-are-hero.png',
    position: STICKER_POSITIONS.BOTTOM_LEFT,
    size: STICKER_SIZES.LARGE,
    rotation: 15,
    category: 'bottom',
  },
  {
    id: 'you-deserve-support',
    name: 'You Deserve Support',
    nameAr: 'تستحقين الدعم',
    file: 'you-deserve-support.png',
    position: STICKER_POSITIONS.BOTTOM_RIGHT,
    size: STICKER_SIZES.XLARGE,
    rotation: -15,
    category: 'bottom',
  },
  {
    id: 'speak-out',
    name: 'Speak Out',
    nameAr: 'تكلمي',
    file: 'speak-out.png',
    position: STICKER_POSITIONS.RIGHT_CENTER,
    size: STICKER_SIZES.MEDIUM,
    rotation: 0,
    category: 'side',
  },
  {
    id: 'you-deserve',
    name: 'You Deserve Sign',
    nameAr: 'لافتة تستحقين',
    file: 'you-deserve.png',
    position: STICKER_POSITIONS.TOP_LEFT,
    size: STICKER_SIZES.MEDIUM,
    rotation: -10,
    category: 'top',
  },
  {
    id: 'woman-heart',
    name: 'Woman Officer',
    nameAr: 'ضابطة',
    file: 'woman-heart.png',
    position: STICKER_POSITIONS.BOTTOM_LEFT,
    size: STICKER_SIZES.LARGE,
    rotation: 0,
    category: 'large',
  },
  {
    id: 'jeep',
    name: 'Police Jeep',
    nameAr: 'سيارة الشرطة',
    file: 'jeep.png',
    position: STICKER_POSITIONS.BOTTOM_RIGHT,
    size: STICKER_SIZES.XLARGE,
    rotation: 15,
    category: 'large',
  },
];

// Get random sticker
export const getRandomSticker = () => {
  const index = Math.floor(Math.random() * STICKERS.length);
  return STICKERS[index];
};

// Get stickers by category
export const getStickersByCategory = (category) => {
  return STICKERS.filter(s => s.category === category);
};

// Calculate sticker position on canvas
export const calculateStickerPosition = (position, imageWidth, imageHeight, stickerWidth, stickerHeight) => {
  const padding = imageWidth * 0.03; // 3% padding from edges

  switch (position) {
    case STICKER_POSITIONS.TOP_LEFT:
      return { x: padding, y: padding };
    case STICKER_POSITIONS.TOP_RIGHT:
      return { x: imageWidth - stickerWidth - padding, y: padding };
    case STICKER_POSITIONS.TOP_CENTER:
      return { x: (imageWidth - stickerWidth) / 2, y: padding };
    case STICKER_POSITIONS.BOTTOM_LEFT:
      return { x: padding, y: imageHeight - stickerHeight - padding };
    case STICKER_POSITIONS.BOTTOM_RIGHT:
      return { x: imageWidth - stickerWidth - padding, y: imageHeight - stickerHeight - padding };
    case STICKER_POSITIONS.BOTTOM_CENTER:
      return { x: (imageWidth - stickerWidth) / 2, y: imageHeight - stickerHeight - padding };
    case STICKER_POSITIONS.LEFT_CENTER:
      return { x: padding, y: (imageHeight - stickerHeight) / 2 };
    case STICKER_POSITIONS.RIGHT_CENTER:
      return { x: imageWidth - stickerWidth - padding, y: (imageHeight - stickerHeight) / 2 };
    default:
      return { x: padding, y: padding };
  }
};
